import { Box, Typography } from '@mui/material';
import zeplinColor from 'theme/Color';
import { Lead } from '../../LeadsKanbanColumn';

export const LeadHeader = ({ selectedData }: { selectedData: Lead }) => {
  return (
    <Box sx={{ display: 'flex', gap: '16px' }}>
      {selectedData?.profileImageUrl ? (
        <img
          src={selectedData?.profileImageUrl}
          alt={selectedData?.name}
          style={{ borderRadius: '14px', width: '60px', height: '60px' }}
        />
      ) : (
        <Box
          sx={{
            borderRadius: '14px',

            width: { xs: '60px', xl: '60px' },
            height: { xs: '60px', xl: '60px' },
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: zeplinColor.Brand1,
          }}
        >
          <Typography variant='responsiveLabel1' color={zeplinColor.Neutral1}>
            {selectedData?.name
              ?.split(' ')
              .map((value: any, index: number) =>
                selectedData?.name &&
                (index === 0 || index === selectedData?.name?.split(' ').length - 1)
                  ? value[0]
                  : '',
              )}
          </Typography>
        </Box>
      )}

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <Typography
          variant='heading2'
          sx={{
            color: zeplinColor.BasicBlack,
            wordBreak: 'break-word',
          }}
        >
          {selectedData.name || 'N/A'}
        </Typography>

        <Typography variant='body2' sx={{ color: zeplinColor.Brand1 }}>
          {selectedData.email || 'N/A'}
        </Typography>
      </Box>
    </Box>
  );
};
